import React from 'react';
import {Col, Image} from "react-bootstrap";
import {Link} from "react-router-dom";
import SlideCard from "./SlideCard";
import './projectCard.css'
import useHandleRequest from "../../../custom_hooks/useHandleRequest";

function ProjectCard({to,title,bgColor,coverImg,logoImg,header,description,category,date}) {
    const {handleRequestAndNavigate} = useHandleRequest();
    return (
            <Col xl={4} lg={6} md={6} sm={12} className={'px-xxl-5 px-lg-4 mb-0 mb-lg-5 mt-4 mt-lg-0'}>
                <Link to={to}
                      className={'p-0 projects-card-wrapper d-block p-2'}
                      onClick={(e) => handleRequestAndNavigate(e, `/project/${to}`, `project/${to}/`, 'project')}
                >
                    <SlideCard title={title} bgColor={bgColor} href={to} cover={coverImg}
                               logo={logoImg}/>
                    <h3 className={'mt-3 p-2 text-end'}>{header}</h3>
                    <p className={'text-end px-2'}>{description}</p>
                    <div className={'footer px-2'}>
                        <p className={'category'}>دسته بندی : {category}</p>
                        <p className={'date'}>تاریخ : <span >{date}</span></p>
                    </div>
                </Link>
            </Col>


    );
}

export default ProjectCard;